import { combineReducers } from 'redux';
import specialTasks from './task';
import specialActivityLogs from './activityLog';

export default combineReducers({
  specialTasks,
  specialActivityLogs,
});
